import React from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import * as Styled from './ChatMarkdown.styles'
import 'katex/dist/katex.min.css'

const REMARK_PLUGINS = [remarkGfm, remarkMath]
const REHYPE_PLUGINS = [rehypeKatex]

interface ChatMarkdownProps {
  content: string
}

const ChatMarkdown: React.FC<ChatMarkdownProps> = React.memo(({ content }) => (
  <Styled.Container>
    <Markdown remarkPlugins={REMARK_PLUGINS} rehypePlugins={REHYPE_PLUGINS}>{content}</Markdown>
  </Styled.Container>
))

export { ChatMarkdown }
